import { inject, Injectable } from "@angular/core";
import { AdresseState, AdresseStoreService } from "./adresse-store.service";
import { EntityFacadeService } from "../../../../shared/store/entity-store/entity-facade.service";
import { EntityMetadata } from "../../../../shared/store/store-types.model";
import { AdresseApiService } from "./adresse-api.service";
import { Adresse } from "../../models/adresse.model";
import {
  Untrack,
  UpdateStatus,
} from "../../../../shared/store/utils/store-utils.service";
import { firstValueFrom } from "rxjs";

@Injectable({ providedIn: "root" })
export class AdresseFacadeService extends EntityFacadeService<
  Adresse,
  AdresseApiService,
  AdresseState,
  EntityMetadata,
  AdresseStoreService
> {
  constructor() {
    const api = inject(AdresseApiService);
    const store = inject(AdresseStoreService);
    super(api, store);
    this.store.initStatus(AdresseFacadeService);
  }

  @Untrack
  @UpdateStatus
  async loadAllForTiers(id: string) {
    const adresses = await this.api.loadAllForTiers(id);

    adresses?.forEach((adresse) => {
      this.store.upsertOne(adresse);
    });

    return adresses;
  }

  @Untrack
  @UpdateStatus
  async loadAllForGroup() {
    const adresses = await this.api.loadAllForGroup();

    adresses?.forEach((adresse) => {
      this.store.upsertOne(adresse);
    });

    return adresses;
  }

  @Untrack
  @UpdateStatus
  async setAdresseLivraisonDefaut(id: string) {
    const adresses = await this.api.setAdresseLivraisonDefaut(id);
    adresses?.forEach((adresse) => {
      this.store.upsertOne(adresse);
    });
    return adresses;
  }

  @Untrack
  @UpdateStatus
  async removeAdresseLivraisonDefaut() {
    const adresses = await this.api.removeAdresseLivraisonDefaut();
    adresses?.forEach((adresse) => {
      this.store.upsertOne(adresse);
    });
    return adresses;
  }

  @Untrack
  @UpdateStatus
  async deactivate(id: string) {
    await firstValueFrom(this.api.remove(id));
    const adresse = this.store.getById(id)();
    if (adresse) {
      this.store.upsertOne({ ...adresse, isActive: false });
    }
  }

  @Untrack
  @UpdateStatus
  async reactivate(id: string) {
    const adresse = await firstValueFrom(this.api.reactivate(id));
    this.store.upsertOne(adresse);
    return adresse;
  }
}
